<!--<div class="c-advance-search__content c-pkg-search">-->
<!--      <div class="c-advance-search__content-top">-->
<!--        <button class="a-btn a-btn&#45;&#45;link c-pkg-search__back-btn" (click)="closeCriteriaBox()">-->
<!--          <svg class="a-icon u-mr"><use xlink:href="#previous"></use></svg>-->
<!--        </button>-->
<!--        <h3 class="t2 c-advance-search__title">Return Flight</h3>-->
<!--        <button class="a-btn a-btn&#45;&#45;link o-modal__inner-close">-->
<!--          <svg class="a-icon o-modal__close-icon">-->
<!--            <use xlink:href="#close"></use>-->
<!--          </svg>-->
<!--        </button>-->
<!--      </div>-->

<!--      <div class="c-advance-search__content-wrap">-->

<!--        &lt;!&ndash; first row &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; &ndash;&gt;-->
<!--        <div class="c-advance-search__search-wrap c-search-flight u-mb+">-->
<!--          <div class="c-advance-search__search-box">-->
<!--            <div class="m-form-field">-->
<!--              <surf-type-ahead-->
<!--                [label]="'From'"-->
<!--                [dataList]="airportList"-->
<!--                [mappings]="['code', 'value']"-->
<!--                [selectedItem]="departureSelectedDeparture"-->
<!--                [paramName]="'ontotext'"-->
<!--                [placeholder]="'Search departure airport'"-->
<!--                [bindFocusOut]="false"-->
<!--                [selectAllOnEnter]="false"-->
<!--                [isOnto]="false"-->
<!--                (returnedData)="returnedDepartureData($event)">-->

<!--                <surf-type-ahead-content-->
<!--                  [typeAheadData]="filteredDepartureList"-->
<!--                  [available]="filteredDepartureList?.length > 0"-->
<!--                  (setItem)="handleDepartureSelection($event)">-->

<!--                  <surf-type-ahead-item (click)="handleDepartureSelection(item)"-->
<!--                                        *ngFor="let item of filteredDepartureList">-->
<!--                    <div class="m-info-set">-->
<!--                      <span class="t5">{{item.value}}</span>-->
<!--                      <span class="s6">Country</span>-->
<!--                    </div>-->
<!--                  </surf-type-ahead-item>-->

<!--                </surf-type-ahead-content>-->

<!--              </surf-type-ahead>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="c-advance-search__search-box">-->
<!--            <div class="m-form-field">-->
<!--              <surf-type-ahead-->
<!--                [label]="'To'"-->
<!--                [dataList]="airportList"-->
<!--                [mappings]="['code', 'value']"-->
<!--                [selectedItem]="departureSelectedArrival"-->
<!--                [paramName]="'ontotext'"-->
<!--                [placeholder]="'Search arrival airport'"-->
<!--                [bindFocusOut]="false"-->
<!--                [selectAllOnEnter]="false"-->
<!--                [isOnto]="false"-->
<!--                (returnedData)="returnedArrivalData($event)">-->

<!--                <surf-type-ahead-content-->
<!--                  [typeAheadData]="filteredArrivalList"-->
<!--                  [available]="filteredArrivalList?.length > 0"-->
<!--                  (setItem)="handleReturnSelection($event)">-->

<!--                  <surf-type-ahead-item (click)="handleReturnSelection(item)" *ngFor="let item of filteredArrivalList">-->
<!--                    <div class="m-info-set">-->
<!--                      <span class="t5">{{item.value}}</span>-->
<!--                      <span class="s6">Country</span>-->
<!--                    </div>-->
<!--                  </surf-type-ahead-item>-->

<!--                </surf-type-ahead-content>-->

<!--              </surf-type-ahead>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->


<!--        &lt;!&ndash; second row &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; &ndash;&gt;-->
<!--        <div class="c-pkg-search__form">-->

<!--          <div class="c-pkg-search__form-item">-->
<!--            <div class="m-form-field">-->
<!--              <label class="m-form-field__label" for="f-name">Guests</label>-->
<!--              <div class="m-form-field__field">-->
<!--                <input class="m-form-field__input" id="f-name" type="text" minlength="0" maxlength="524288"-->
<!--                       placeholder="Guests" value="2 Adults">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="c-pkg-search__form-item">-->
<!--            <div class="m-form-field">-->
<!--              <label class="m-form-field__label">Departure & Return Dates*</label>-->
<!--              <div class="m-form-field__field">-->
<!--                <input class="m-form-field__input" type="text" minlength="0" maxlength="524288" placeholder="From"-->
<!--                       value="27 Sep 2019">-->
<!--                <span class="m-form-field__separator"></span>-->
<!--                <input class="m-form-field__input" type="text" minlength="0" maxlength="524288" placeholder="To"-->
<!--                       value="1 Oct 2019">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="c-pkg-search__form-item">-->
<!--            <div class="m-form-field">-->
<!--              <surf-ul-drop-down-->
<!--                [label]="'Cabin class'"-->
<!--                [labelStyle]="'m-form-field__label'"-->
<!--                [items]="cabinClassList"-->
<!--                [placeholder]="''"-->
<!--                [triggerType]="'button'"-->
<!--                [listStyle]="'m-form-field__field'"-->
<!--                [required]="true"-->
<!--                [firstDisplay]="''"-->
<!--                [select]=true-->
<!--                (singleObject)="handleCabinClassSelection($event,'departure')">-->
<!--              </surf-ul-drop-down>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->

<!--      <div class="c-search-flight__title u-mt">-->
<!--        <span class="title-text">Main Airline</span>-->
<!--        <span class="title-line"></span>-->
<!--      </div>-->

<!--      <div class="c-search-flight__tag">-->
<!--        &lt;!&ndash;      <surf-chip *ngFor="let airline of airlineList"&ndash;&gt;-->
<!--        &lt;!&ndash;                 [code]="airline.code"&ndash;&gt;-->
<!--        &lt;!&ndash;                 [selected]="airline.selected"&ndash;&gt;-->
<!--        &lt;!&ndash;                 [value]="airline.value"&ndash;&gt;-->
<!--        &lt;!&ndash;                 (getValue)="handleAirlineSelection($event)">&ndash;&gt;-->
<!--        &lt;!&ndash;      </surf-chip>&ndash;&gt;-->
<!--        <span class="a-pills t-light airline-tag"><span style="background-image: url(http://placehold.it/20x20.jpg);"><img alt="Recommend" src="http://placehold.it/20x20.jpg" style="display: none;"></span> Virgin Airlines</span>-->
<!--        <span class="a-pills t-light airline-tag"><span style="background-image: url(http://placehold.it/20x20.jpg);"><img alt="Recommend" src="http://placehold.it/20x20.jpg" style="display: none;"></span> Sri Lankan AIrlines</span>-->
<!--        <span class="a-pills t-light airline-tag"><span style="background-image: url(http://placehold.it/20x20.jpg);"><img alt="Recommend" src="http://placehold.it/20x20.jpg" style="display: none;"></span> Qantas Airways</span>-->
<!--        <span class="a-pills t-light airline-tag"><span style="background-image: url(http://placehold.it/20x20.jpg);"><img alt="Recommend" src="http://placehold.it/20x20.jpg" style="display: none;"></span> Emirates</span>-->
<!--        <span class="a-pills t-light airline-tag"><span style="background-image: url(http://placehold.it/20x20.jpg);"><img alt="Recommend" src="http://placehold.it/20x20.jpg" style="display: none;"></span> Cathay Pacific Airlines</span>-->
<!--        <span class="a-pills t-light airline-tag"><span style="background-image: url(http://placehold.it/20x20.jpg);"><img alt="Recommend" src="http://placehold.it/20x20.jpg" style="display: none;"></span> Brutish Airways</span>-->
<!--        <span class="a-pills t-light airline-tag"><span style="background-image: url(http://placehold.it/20x20.jpg);"><img alt="Recommend" src="http://placehold.it/20x20.jpg" style="display: none;"></span> Singapore Airways</span>-->
<!--        <span class="a-pills t-light airline-tag"><span style="background-image: url(http://placehold.it/20x20.jpg);"><img alt="Recommend" src="http://placehold.it/100x100.jpg" style="display: none;"></span> Delta Airlines</span>-->
<!--      </div>-->

<!--      <div class="c-search-flight__title">-->
<!--        <button class="a-btn a-btn&#45;&#45;link">See all 32 airlines</button>-->
<!--      </div>-->

<!--      <div class="c-advance-search__btn-wrapper">-->
<!--        <div class="c-advance-search__search-info">-->
<!--          <svg class="a-icon search-info&#45;&#45;icon">-->
<!--            <use xlink:href="#info"></use>-->
<!--          </svg>-->
<!--          <span>Please select at least your <b>Depature, Return dates</b> and <b>From, To Airport</b> to continue search</span>-->
<!--        </div>-->
<!--        <div class="c-advance-search__search-action">-->
<!--          <button class="a-btn a-btn&#45;&#45;default a-btn&#45;&#45;default&#45;&#45;large">Reset Search</button>-->
<!--          <button class="a-btn a-btn&#45;&#45;primary a-btn&#45;&#45;primary&#45;&#45;large is-disabled">Search Flight</button>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->

